import type { WorkOrderItem } from "features/WorkOrders/types/work-order.types";
import { mapApiWorkOrderItemToFormRow } from "features/WorkOrders/utils/work-order-item.utils";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

/** Map work order BOQ lines into rows for the material-request BOQ (quotation row shape). */
export function workOrderItemsToMrBoqRows(
  items: WorkOrderItem[] | null | undefined,
): QuotationItemFormRow[] {
  const rows = items ?? [];
  if (rows.length === 0) return [];
  return rows.map((item) => {
    const row = mapApiWorkOrderItemToFormRow(item);
    const type = (row.type as QuotationItemType) ?? QuotationItemType.MATERIAL;
    const qty = row.qty > 0 ? row.qty : 1;
    const rate = Number.isFinite(Number(row.rate)) ? Number(row.rate) : 0;
    const description =
      String(row.description ?? "").trim() ||
      item.product?.name?.trim() ||
      "";
    const unit = String(row.unit ?? "").trim();
    const pid = row.productId;
    const id =
      row.id != null && Number.isFinite(Number(row.id)) && Number(row.id) > 0
        ? Number(row.id)
        : undefined;
    return {
      ...(id != null ? { id } : {}),
      type,
      description:
        description ||
        (pid !== "" && pid != null && Number(pid) > 0 ? `Product #${pid}` : ""),
      productId: pid !== "" && pid != null && Number(pid) > 0 ? Number(pid) : "",
      quantity: qty,
      unit,
      rate,
    };
  });
}
